// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Body Section */
.body {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100vh;
  min-height: 56rem;
  padding-top: 25rem;
  overflow: hidden;
}

.body-container {
  transform: scale(1.32);
  overflow: hidden;
}

@media (max-width: 600px) {
  .body-profile {
    transform: scale(0.5);
  }

  .body-container {
    top: -15%;
  }

  .console-text {
    font-size: 0.2rem;
  }
}

.body .body-container {
  position: relative;
  display: flex;
  max-width: 120rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
}

.body-profile {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 20rem;
}

.body-img {
  width: 100%;
  transform: scale(3);
  border-radius: 100%;
}

.body-content {
  padding-top: 20rem;
  text-align: center;
}

.body-headline {
  font-size: 5rem;
  padding-bottom: 1rem;
  color: white;
}

.body-text {
  font-size: 2rem;
  padding-bottom: 1rem;
  color: lightgray;
}

.body-icons {
  display: flex;
  width: 100%;
  justify-content: center;
  font-size: 8rem;
  padding: 2rem 0 2rem 0;
}

.body .icon-link {
  padding: 0.8rem 0.8rem;
  color: white;
}

.icon-link:hover {
  color: lightgray;
  transform: scale(1.05);
}

@media (min-width: 601) and (max-width: 768px) {
  .body .body-container {
    max-width: 90%;
  }

  .body-profile {
    max-width: 15rem;
  }

  .body-headline {
    font-size: 2.5rem;
  }

  .body-text {
    font-size: 1.2rem;
  }

}

@media (max-width: 600px) {
  .body-img {
    height: 100%;
    max-width: auto;
    transform: scale(1.5);
  }
}


.console-container {
  position: absolute;
  top: 0%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  /* Adjust the opacity and color as desired */
  z-index: 0;
  overflow: hidden;
}

.console-text {
  font-family: monospace;
  font-weight: bold;
  font-size: 2rem;
  margin: 0;
  padding: 0;
  line-height: 1;
  color: limegreen;
  text-shadow: 0px 0px 10px limegreen;
  animation: scrollText 30s linear infinite;
}

@media (max-width: 600px) {
  .console-text {
    font-size: 1rem;
  }
}

@keyframes scrollText {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-100%);
  }
}

.msg {
  font-family: monospace;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 3rem;
  padding-top: 0.3rem;
  background: red;
  box-shadow: 0 0 30px red;
  text-shadow: 0 0 20px white;
  color: white;
  height: 4rem;
  text-align: center;
  min-width: 200px;
  animation-name: blink;
  animation-duration: 1.2s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: linear;
  align-items: center;
}

@keyframes blink {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

/* End Body Section */

`, "",{"version":3,"sources":["webpack://./src/components/Body.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;AAEF;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;IACf,qBAAqB;EACvB;AACF;;;AAGA;EACE,kBAAkB;EAClB,OAAO;EACP,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,4CAA4C;EAC5C,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,mCAAmC;EACnC,8BAA8B;EAC9B,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,qBAAqB","sourcesContent":["/* Body Section */\n.body {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: 100vh;\n  min-height: 56rem;\n  padding-top: 25rem;\n  overflow: hidden;\n}\n\n.body-container {\n  transform: scale(1.32);\n  overflow: hidden;\n}\n\n@media (max-width: 600px) {\n  .body-profile {\n    transform: scale(0.5);\n  }\n\n  .body-container {\n    top: -15%;\n  }\n\n  .console-text {\n    font-size: 0.2rem;\n  }\n}\n\n.body .body-container {\n  position: relative;\n  display: flex;\n  max-width: 120rem;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex-grow: 1;\n}\n\n.body-profile {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  max-width: 20rem;\n}\n\n.body-img {\n  width: 100%;\n  transform: scale(3);\n  border-radius: 100%;\n}\n\n.body-content {\n  padding-top: 20rem;\n  text-align: center;\n}\n\n.body-headline {\n  font-size: 5rem;\n  padding-bottom: 1rem;\n  color: white;\n}\n\n.body-text {\n  font-size: 2rem;\n  padding-bottom: 1rem;\n  color: lightgray;\n}\n\n.body-icons {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  font-size: 8rem;\n  padding: 2rem 0 2rem 0;\n}\n\n.body .icon-link {\n  padding: 0.8rem 0.8rem;\n  color: white;\n}\n\n.icon-link:hover {\n  color: lightgray;\n  transform: scale(1.05);\n}\n\n@media (min-width: 601) and (max-width: 768px) {\n  .body .body-container {\n    max-width: 90%;\n  }\n\n  .body-profile {\n    max-width: 15rem;\n  }\n\n  .body-headline {\n    font-size: 2.5rem;\n  }\n\n  .body-text {\n    font-size: 1.2rem;\n  }\n\n}\n\n@media (max-width: 600px) {\n  .body-img {\n    height: 100%;\n    max-width: auto;\n    transform: scale(1.5);\n  }\n}\n\n\n.console-container {\n  position: absolute;\n  top: 0%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0);\n  /* Adjust the opacity and color as desired */\n  z-index: 0;\n  overflow: hidden;\n}\n\n.console-text {\n  font-family: monospace;\n  font-weight: bold;\n  font-size: 2rem;\n  margin: 0;\n  padding: 0;\n  line-height: 1;\n  color: limegreen;\n  text-shadow: 0px 0px 10px limegreen;\n  animation: scrollText 30s linear infinite;\n}\n\n@media (max-width: 600px) {\n  .console-text {\n    font-size: 1rem;\n  }\n}\n\n@keyframes scrollText {\n  0% {\n    transform: translateY(0);\n  }\n\n  100% {\n    transform: translateY(-100%);\n  }\n}\n\n.msg {\n  font-family: monospace;\n  font-weight: bold;\n  text-transform: uppercase;\n  font-size: 3rem;\n  padding-top: 0.3rem;\n  background: red;\n  box-shadow: 0 0 30px red;\n  text-shadow: 0 0 20px white;\n  color: white;\n  height: 4rem;\n  text-align: center;\n  min-width: 200px;\n  animation-name: blink;\n  animation-duration: 1.2s;\n  animation-iteration-count: infinite;\n  animation-direction: alternate;\n  animation-timing-function: linear;\n  align-items: center;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n/* End Body Section */\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
